import { httpPost } from '../../components/utils';
import { getFullUrl } from '../utils';
import { QueryParams } from '../types/QueryParams';

export const apiPost = async <TData, TResponse = unknown>(
    url: string,
    data?: TData,
    queryParams: QueryParams = {}
): Promise<TResponse> => {
    const fullUrl = getFullUrl(url, queryParams);
    const response = await httpPost(fullUrl, data);
    return response.data as TResponse;
};
